"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WherebyRoomNo = /** @class */ (function () {
    function WherebyRoomNo() {
    }
    WherebyRoomNo.generate = function (excludes) {
        if (excludes === void 0) { excludes = []; }
        var randomNo = Math.floor(Math.random() * WherebyRoomNo.MAX_ROOM_NO);
        if (!excludes.includes(randomNo)) {
            return randomNo;
        }
        return WherebyRoomNo.generate(excludes);
    };
    Object.defineProperty(WherebyRoomNo, "MAX_ROOM_NO", {
        get: function () {
            return 9999;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WherebyRoomNo, "MAX_LENGTH", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    WherebyRoomNo.toString = function (roomNo) {
        return ('0000' + roomNo).slice(-WherebyRoomNo.MAX_LENGTH);
    };
    return WherebyRoomNo;
}());
exports.default = WherebyRoomNo;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/whereby/room_no.ts
// module id = tCzR
// module chunks = 1